import '../styles/home.css';
import StoryHome from '../Components/StoryHome';
import Construtoras from '../Components/Construtoras';
import InvestirMorar from '../Components/InvestirMorar';
import Sobre from '../Components/Sobre';


function Home() {
  return (
    <div className="App">
      <StoryHome />
      <Construtoras />
      <InvestirMorar />
      <Sobre />
    </div>
  );
}

export default Home;
